
import { Injectable, DOCUMENT, inject } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class FaviconUtilsService {
    private document = inject<Document>(DOCUMENT);


    public setFavicon(faviconUrl: string | undefined) {
        if (faviconUrl) {
            this.document.head.appendChild(this.getFaviconElement(faviconUrl));
        }
    }

    private getFaviconElement(faviconPath:string): Node {
        const faviconLinkElement = this.document.createElement('link');
        faviconLinkElement.setAttribute('rel', 'icon');
        faviconLinkElement.setAttribute('type', 'image/x-icon');
        faviconLinkElement.setAttribute('href', faviconPath);
        faviconLinkElement.setAttribute('onerror', "this.onerror=null;this.src='./favicon.ico'");
        return faviconLinkElement;
    }
}
